var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');
var GetEntity = require('../services/GetEntity');

var COCEntityEditView = require('../views/COCEntityEditView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetAllEntityLookups(), GetEntity(entityId))
    .done(function(lookups, entity) {
      NavUtils.navigate('coc/entity/' + entityId + '/edit');

      Scaffold.content.show(
        new COCEntityEditView({
          model: new Backbone.Model({
            entity: entity,
            entityTypes: lookups.entityTypes,
            organizationTypes: lookups.organizationTypes
          })
        })
      );

      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
